import React from 'react'

const services = [
    { imagesUrl: "Mask group (1)", name: "Construction & Masonry" },
    { imagesUrl: "Mask group (2)", name: "Vehicle Repair & Maintenance" },
    { imagesUrl: "Mask group (3)", name: "Tutoring" },
    { imagesUrl: "Mask group (4)", name: "Lawyers" },

]

const RecentServices= () =>{
    return (
        <>
            <div className='maincontainer'>
                <h2>Recent Services</h2>
                <div className='row'>
                    {
                        services.map((service, index) => {
                            return (
                                <div className="col-lg-3 col-md-4 col-sm-6">
                                    <div className="recent-service-imagebox" key={index}>
                                        <div className="recent-service-thumbnail">
                                            <img src={`assets/images/${service.imagesUrl}.png`} alt="" />
                                        </div>
                                        <div className="recent-service-content">
                                            <div className="recent-service-content-box-inner">
                                                <p>{service.name}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }

                </div>
            </div>

        </>
    )
}

export default RecentServices;